// components/industry-templates/MentalHealthEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Heart, Brain, Users, MessageCircle } from 'lucide-react';

export const MentalHealthEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Always show event description */}
      <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Brain className="w-6 h-6" style={{ color: theme.primary }} />
            About This Event
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-slate-300 leading-relaxed">{structure.description}</p>
        </CardContent>
      </Card>

      {/* Show topics if available */}
      {structure.topics && structure.topics.length > 0 && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <MessageCircle className="w-6 h-6" style={{ color: theme.primary }} />
              Topics Covered
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-2">
              {structure.topics.map((topic: string, idx: number) => (
                <Badge key={idx} style={{ backgroundColor: theme.primary }} className="text-sm py-2 px-4">
                  {topic}
                </Badge>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Mental Health Focus Areas - Default content when data is minimal */}
      <Card className="border-0 bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Heart className="w-8 h-8" style={{ color: theme.primary }} />
            Mental Health & Wellness
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {['Therapy Sessions', 'Mindfulness', 'Support Groups', 'Counseling'].map((item, idx) => (
              <div key={idx} className="p-4 bg-white/10 rounded-xl text-center">
                <div className="text-3xl mb-2">🧠</div>
                <p className="text-white font-medium">{item}</p>
              </div>
            ))}
          </div>
          {industryData?.therapy && (
            <div className="mt-4 p-4 bg-white/5 rounded-lg">
              <p className="text-white">✓ Professional therapy sessions available</p>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Event Format */}
      <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Users className="w-6 h-6" style={{ color: theme.primary }} />
            Event Format
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <Badge style={{ backgroundColor: theme.primary }}>
                {structure.format === 'hybrid' ? '🌐 Hybrid' : structure.format === 'virtual' ? '💻 Virtual' : '📍 In-Person'}
              </Badge>
              <span className="text-white capitalize">{structure.format} Event</span>
            </div>
            <div className="flex items-center gap-3">
              <Badge style={{ backgroundColor: theme.primary}}>
                📅 {structure.event_type}
              </Badge>
              <span className="text-white capitalize">{structure.event_type}</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
